<template>
  <hr class="ah-divider"/>
</template>

<script>
  export default {
    name: 'divider',
  }
</script>

<style lang="scss" scoped>
  .ah-divider {
    border: 0;
    height: 0;
    border-top: 1px solid #DCDCE5;
    border-bottom: none;
  }
</style>
